import { render, staticRenderFns } from "./LsportDetailCorrectScoreLock.vue?vue&type=template&id=78102341&scoped=true"
import script from "./LsportDetailCorrectScoreLock.vue?vue&type=script&lang=js"
export * from "./LsportDetailCorrectScoreLock.vue?vue&type=script&lang=js"
import style0 from "./LsportDetailCorrectScoreLock.vue?vue&type=style&index=0&id=78102341&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78102341",
  null
  
)

export default component.exports